/**
 * Get the appropriate icon for a sport type
 * @param sport - The sport slug (e.g., "padel", "tennis")
 * @returns The iconify icon string
 */
export function getSportIcon(sport: string): string {
  switch (sport) {
    case "padel":
      return "game-icons:tennis-racket";
    case "tennis":
      return "game-icons:tennis-ball";
    case "badminton":
      return "game-icons:badminton-shuttlecock";
    case "squash":
      return "game-icons:squash-racket";
    case "pickleball":
      return "mdi:racquetball";
    default:
      return "game-icons:trophy";
  }
}
